import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";

import "react-datetime/css/react-datetime.css";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../actions/useaxios";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router";
import { LoadToast, updateToast } from "../../actions/common";

function ContactusList() {
  const navigate = useNavigate();
  const [dtlists, setDtlists] = useState([]);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const axiosFile = useAxiosFile();

  useEffect(() => {
    showdata();
  }, []);

  const showdata = async () => {
    console.log("ddddd");
    var data = await axiosFile.GetContactList();
    console.log("vvvv", data);
    setDtlists(data?.data);
  };

  const submitbtn = async (cell) => {
    console.log("rtg", cell);
    navigate(`/contactdetail`, { state: cell });
  };

  const clickbtn = async (cell) => {
    const id = LoadToast();
    console.log("ccc", cell);
    const updatedata = {
      _id: cell._id,
      action: "statusupdate",
      status: true,
    };
    var data = await axiosFile.GetContactList();
    console.log("ttttttttrue", data);
    updateToast(id, data.msg, data.success);
    if (data?.success == "success") {
      showdata();
    }
  };
  const columns = [
    {
      dataField: "EmailId",
      text: "Email Id",
      sort: true,
      formatter: (cell, row) => (
        <div>
          {console.log('cellcell', cell, row)}
          {cell}
        </div>
      ),
    },
    {
      dataField: "Message",
      text: "Message",
      sort: true,
      formatter: (cell, row) => <div>{cell?.length > 20 ? cell.substring(0, 20) + "..." : cell}</div>,
    },
    {
      dataField: "hideshow",
      text: "View",
      formatter: (cell, row) => (
        <button
          class="blue_btn add_deliveryprsn dp_btn_hover"
          type="button"
          onClick={() => submitbtn(row)}
        >
          View/Reply
        </button>
      ),
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  return (
    <div>
      {console.log("dftgdf", dtlists)}

      <div className="innerpages">
        <div className="orders_pages">
          <Headers />
          <div className="container custom_container px-lg-0">
            <div className="row mx-auto">
              <div className="innerpages_wid px-0">
                <Sidebar />
                <div
                  className={
                    toggle
                      ? "content-sec-inner right_widthset content_without_sidebar"
                      : "content-sec-inner  content_with_sidebar"
                  }
                >
                  <section id="content-wrapper">
                    <div class="row">
                      <div className="top_title_sec">
                        <div>
                          <p className="page_title">Contact Us List</p>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 mx-auto">
                      <div className="sec_border">
                        <div className="row">
                          {
                            dtlists?.length > 0 &&
                            <div className="ffd_table mar_bot vendor_table_align">
                              <BootstrapTable
                                bootstrap4
                                keyField="id"
                                columns={columns}
                                data={dtlists}
                                pagination={pagination}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ContactusList;
